import classNames from 'classnames';
import GlooBlack from 'assets/Gloo_Wordmark_Charcoal.png';
import GlooWhite from 'assets/Gloo_Wordmark_White.svg';
import { twMerge } from 'tailwind-merge';

interface LogoProps {
  size?: 'small' | 'large' | 'xl';
  color?: 'white' | 'black';
  className?: string;
  onClick?: any;
}

function GlooLogo({ size, color }: Partial<LogoProps>) {
  return (
    <img
      src={color && color === 'white' ? GlooWhite : GlooBlack}
      alt="Gloo"
      data-durable-id="navGlooIcon"
      className=""
      style={{ maxHeight: size === 'small' ? 25 : size === 'large' ? 60 : size === 'xl' ? 75 : 32 }}
    />
  );
}

function Logo({ className, onClick, ...rest }: LogoProps) {
  return (
    <div
      className={twMerge(
        'text-white flex flex-col items-center justify-center',
        classNames({ 'cursor-pointer': onClick }),
        className,
      )}
      onClick={onClick}
    >
      <GlooLogo {...rest} />
    </div>
  );
}

export default Logo;
